import * as React from "react";

export default function Loading() {
  return (
    <div style={{ backgroundColor: "#44AD5E", height: 900 }}>
      <div
        style={{
          fontSize: 70,
          textAlign: "center",
          lineHeight: 9,
          color: "whitesmoke",
        }}
      >
        welcome!
      </div>
    </div>
  );
}
